import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
// import frameStore from '@frame/store'
/* 开启vue-dev-tools */
if (process.env.NODE_ENV === 'development') Vue.config.devtools = true
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    currentSystemTheme: 'lightblue',
    clientIp: '',
    userlist: [],
    remUser: false,
    proUser: false,
    token: '',
    ucWsCurrUser: '',
    out: false,
    reload: false,
    limit: [],
    hasGetMenu:false,
    hasImport:false,
  },
  mutations: {
    SWITCH_CURRENT_SYSTEM_THEME (state, theme) {
      state.currentSystemTheme = theme
    },
    SET_CLIENTIP (state, theme) {
      state.clientIp = theme
    },
    SET_USERLIST (state, theme) {
      state.userlist = theme
    },
    SET_REMUSER (state, theme) {
      state.remUser = theme
    },
    SET_PROUSER (state, theme) {
      state.proUser = theme
    },
    SET_TOKEN (state, theme) {
      state.token = theme
    },
    SET_UCWSCURRUSER (state, theme) {
      state.ucWsCurrUser = theme
    },
    SET_OUT (state, theme) {
      state.out = theme
    },
    SET_RELOAD (state, theme) {
      state.reload = theme
    },
    SET_LIMIT (state, theme) {
      state.limit = theme
    },
    REMOVE_CLIENTIP (state) {
      state.clientIp = ''
    },
    REMOVE_USERLIST (state) {
      state.userlist = []
    },
    REMOVE_REMUSER (state) {
      state.remUser = false
    },
    REMOVE_PROUSER (state) {
      state.proUser = false
    },
    REMOVE_TOKEN (state) {
      state.token = ''
    },
    REMOVE_UCWSCURRUSER (state) {
      state.ucWsCurrUser = ''
    },
    REMOVE_OUT (state) {
      state.out = false
    },
    REMOVE_RELOAD (state) {
      state.reload = false
    },
    REMOVE_LIMIT (state) {
      state.limit = []
    },
    SET_DET_MENU(state, data) {
      state.hasGetMenu = data
    },
    SET_HAS_IMPORT(state, data) {
      state.hasImport = data
    },
  },
  getters: {
    clientIp: state => state.clientIp,
    userlist: state => state.userlist,
    remUser: state => state.remUser,
    proUser: state => state.proUser,
    token: state => state.token===''?Cookies.get('user_token'):state.token,
    ucWsCurrUser: state => state.ucWsCurrUser,
    out: state => state.out,
    reload: state => state.reload,
    limit: state => state.limit,
  },
  actions:{
    setGetMenu({commit},data){
      commit('SET_DET_MENU',data)
    }
  }
})
export default store
